module.exports = __webpack_public_path__ + "8b128770288bf55a27196ba2836a736a.png";